// Client-side password strength feedback mirroring the legacy activate_account
// rules (min 12 chars + upper + lower + digit + special). This is UX guidance
// only — the server (core/security.py, NIST 800-63B-4) is the real gate.

export interface PasswordChecks {
  length: boolean;
  upper: boolean;
  lower: boolean;
  digit: boolean;
  special: boolean;
}

export function passwordChecks(pw: string): PasswordChecks {
  return {
    length: pw.length >= 12,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /\d/.test(pw),
    special: /[^A-Za-z0-9]/.test(pw),
  };
}

/** 0–5: how many criteria are satisfied. */
export function passwordScore(checks: PasswordChecks): number {
  return Object.values(checks).filter(Boolean).length;
}

export interface Strength {
  label: "Weak" | "Fair" | "Strong";
  pct: number;
  level: "weak" | "fair" | "strong";
}

export function passwordStrength(pw: string): Strength {
  const score = passwordScore(passwordChecks(pw));
  const pct = (score / 5) * 100;
  if (score <= 2) return { label: "Weak", pct, level: "weak" };
  if (score <= 4) return { label: "Fair", pct, level: "fair" };
  return { label: "Strong", pct, level: "strong" };
}
